import axios from 'axios';

export default (BASE_URL) => ({
  loadProjects: function() {
    // /api/projects
    return axios.get(BASE_URL + 'projects')
  },
  loadProjectById: function (projectId) {
    // /api/projects/:projectId
    return axios.get(BASE_URL + 'projects/' + projectId)
  },
  updateProject: function(projectId, newProject) {
    // UPDATE /api/:projectId/scene/:sceneId -- update scene data
    return axios.put(BASE_URL + 'projects/' + projectId, {"project": newProject})
  },
  deleteProject: function(projectId) {
    // UPDATE /api/:projectId/scene/:sceneId -- update scene data
    return axios.delete(BASE_URL + 'projects/' + projectId)
  },
});
